export const Checkbox = 'Checkbox';
export const Radio = 'Radio';
